export enum SupervsorAlerts {
  CHECK_INS = "CHECK_INS",
  CHECK_OUTS = "CHECK_OUTS",
  ALL = "ALL",
}

export type TEmployeeFormData = {
  firstName: string;
  lastName: string;
  birthDate: Date;
  dlStateN: string;
  ssn: string;
  hireDate: Date;
  email: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  ZIP: string;
  homePhone: string;
  workPhone: string;
  emergencyContact: string;
  emergencyContactName: string;
  payRate: number;
  overTimeRate: number;
  desiredHoursPerWeek: number;
  supervisorAlerts?: SupervsorAlerts;
  accountName: string;
  routingNumber: string;
  accountNumber: string;
  notes: string;
  role: string;
  confirmAccountNumber: string;
  mobileAccess: boolean;
  pdfAttachmentsArr: File[] | null;
  otherDocumentsArr: File[];
  notifyEmailChange?: boolean;
};
